import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PrivateRoute } from './PrivateRoute';
import LoaderComponenet from '../components/UIComponents/Loader';

const Dashboard = lazy(() => import('../pages/Dashboard'));
const Employees = lazy(() => import('../pages/Employees'));
const AddEmployee = lazy(() => import('../pages/Employees/AddEmployee'));
const EmployeeDetail = lazy(() => import('../pages/EmployeeDetail'));
const EditEmployee = lazy(() => import('../pages/EmployeeDetail/EditEmployee'));
const AddEmployeeDependent = lazy(() => import('../pages/EmployeeDetail/AddDependent'));
const Policy = lazy(() => import('../pages/Policy'));
const Login = lazy(() => import('../pages/Login'));
const ResetPassword = lazy(() => import('../pages/ResetPassword'));
const Wellness = lazy(() => import('../pages/Wellness'));
const Report = lazy(() => import('../pages/Report'));
const Support = lazy(() => import('../pages/Support'));
const Profile = lazy(() => import('../pages/Profile'));
const Welcome = lazy(() => import('../pages/Welcome'));
const NotFound = lazy(() => import('../pages/404'));

const OperatorRequestsPending = lazy(() =>
  import('../pages/Dashboard/ActionCenter/Operator/RequestsPending'),
);
const OperatorRequestsResolved = lazy(() =>
  import('../pages/Dashboard/ActionCenter/Operator/RequestsResolved'),
);
const AdminRequestsPending = lazy(() =>
  import('../pages/Dashboard/ActionCenter/Admin/RequestsPending'),
);
const AdminRequestsResolved = lazy(() =>
  import('../pages/Dashboard/ActionCenter/Admin/RequestsResolved'),
);

const RouteSetup = () => {
  return (
    <Suspense fallback={<LoaderComponenet />}>
      <Routes>
        <Route path="/welcome" element={<Welcome />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/employees"
          element={
            <PrivateRoute>
              <Employees />
            </PrivateRoute>
          }
        />
        <Route
          path="/employees/:id"
          element={
            <PrivateRoute>
              <EmployeeDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/employees/edit/:id"
          element={
            <PrivateRoute>
              <EditEmployee />
            </PrivateRoute>
          }
        />
        <Route
          path="/employees/add"
          element={
            <PrivateRoute>
              <AddEmployee />
            </PrivateRoute>
          }
        />
        <Route
          path="/employees/add-dependent/:id"
          element={
            <PrivateRoute>
              <AddEmployeeDependent />
            </PrivateRoute>
          }
        />
        <Route
          path="/policy"
          element={
            <PrivateRoute>
              <Policy />
            </PrivateRoute>
          }
        />
        <Route
          path="/wellness"
          element={
            <PrivateRoute>
              <Wellness />
            </PrivateRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <Report />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/operator-request/pending"
          element={
            <PrivateRoute>
              <OperatorRequestsPending />
            </PrivateRoute>
          }
        />
        <Route
          path="/operator-request/resolved"
          element={
            <PrivateRoute>
              <OperatorRequestsResolved />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-request/pending"
          element={
            <PrivateRoute>
              <AdminRequestsPending />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin-request/resolved"
          element={
            <PrivateRoute>
              <AdminRequestsResolved />
            </PrivateRoute>
          }
        />
        <Route
          path="/support"
          element={
            <PrivateRoute>
              <Support />
            </PrivateRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-email" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default RouteSetup;
